// extracted by mini-css-extract-plugin
export default {"select":"Select2_select__m03OL"};